module.exports = __webpack_public_path__ + "static/img/lato-v23-latin-ext_latin-regular.9087e4a.svg";